import React, { FC, memo } from 'react';

const SIZE_PX = 112;

/** Inline SVG clock used on the 408 "Still securing file" screen. */
const SecuringClockIcon: FC = () => (
    <svg
        width={SIZE_PX}
        height={SIZE_PX}
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <circle cx="100" cy="100" r="72" stroke="#0F778C" strokeWidth="6" fill="#E8F6F8" />
        <circle cx="100" cy="100" r="62" stroke="#091F56" strokeWidth="2" strokeOpacity="0.12" />
        <path
            d="M100 58v46l28 16"
            stroke="#091F56"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M148 44l8-8M52 44l-8-8" stroke="#0F778C" strokeWidth="4" strokeLinecap="round" />
        <circle cx="100" cy="100" r="5" fill="#091F56" />
    </svg>
);

export default memo(SecuringClockIcon);
